import * as Sentry from "@sentry/react";

Sentry.init({
 dsn: "https://a232e992405067677df7bbe16c127a30@o4509592757403648.ingest.us.sentry.io/4509593692536832",
   // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration()
  ],
   tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api\//],
 // Enable logs to be sent to Sentry
  _experiments: { enableLogs: true },
  debug: true,  
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 100%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
 